





































































import Vue from 'vue';
import Component from 'vue-class-component';
import {Emit, Prop, PropSync, Watch} from 'vue-property-decorator';
import {TaskModel} from '@/models/task.model';
import {acceptedModule, challengeModule, tasksState} from '@/utils/store-acessor';
import {ChallengeModel} from '@/models/challenge.model';

@Component({})
export default class TaskCard extends Vue {
  @PropSync('task', {required: true}) selectedTask!: TaskModel;
  @Prop({required: false}) width!: number;
  @Prop({required: false}) height!: number;
  @Prop({required: true}) descriptionHeight!: number;
  @Prop({required: false}) descriptionLimit!: number;
  @challengeModule.Getter('selectedChallenge') challenge!: ChallengeModel;
  @acceptedModule.Getter('userHasAccepted') userHasAccepted!: (challengeId: number) => boolean;

  loading = false;
  snackbarVisibility = false;
  snackbarColor: 'green' | 'red' = 'green';
  snackbarMessage = '';

  @Watch('task')
  onTaskChange(value: TaskModel) {
    this.taskUpdated(value)
  }

  formatTitle(count: number): string {
    if (count < 2) {
      return this.$tc('tasks.labels.users', 1).toString()
    }
    return this.$tc('tasks.labels.users', 2).toString()
  }

  formatDescription(): string {
    if (this.selectedTask?.description) {
      if (this.selectedTask.description.length >= this.descriptionLimit) {
        const newDescription = this.selectedTask.description.slice(0, this.descriptionLimit);
        return `${newDescription}...`
      }
      return this.selectedTask.description
    }
    return ''
  }

  hasSlots(): boolean {
    if (this.selectedTask) {
      if (this.selectedTask.max_users === 'Unlimited') {
        return true;
      }
      const joined: number = this.selectedTask.joined_users || 0;
      const max: number = this.selectedTask.max_users || 0;
      return joined <= max
    }
    return false
  }

  @Emit()
  taskUpdated(value: TaskModel): TaskModel {
    return value
  }

  @Emit()
  onTaskSelected(): TaskModel {
    return this.selectedTask;
  }

  async onClickToJoin() {
    this.loading = false;
    if (this.selectedTask?.id && this.selectedTask?.challenge_id) {
      try {
        this.loading = true;
        await tasksState.acceptTask({
          taskId: this.selectedTask.id,
          challengeId: this.selectedTask.challenge_id
        });
        this.showFeedback('tasks.messages.accept_success', 'green')
      } catch (e) {
        this.showFeedback('tasks.messages.accept_fail', 'red')
      } finally {
        this.loading = false;
      }
    }
  }

  async onClickToAbort() {
    this.loading = false;
    if (this.selectedTask?.id && this.selectedTask?.challenge_id) {
      this.loading = true;
      try {
        await tasksState.abortTask({
          taskId: this.selectedTask.id,
          challengeId: this.selectedTask.challenge_id
        });
        this.showFeedback('tasks.messages.abort_success', 'green')
      } catch (e) {
        this.showFeedback('tasks.messages.abort_fail', 'red')
      } finally {
        this.loading = false;
      }
    }
  }

  private showFeedback(message: string, color: 'red' | 'green') {
    this.snackbarColor = color;
    this.snackbarMessage = message;
    this.snackbarVisibility = true;
  }
}
